import { del, get, patch, post, put } from "helpers/api_helper";
import jpPostCode from "japan-postal-code";
import * as url from "../url_helper";

export const apiSignUpClinic = (body = {}) => {
  return put(`/master/account/clinics/`, body);
};

/**
 *
 * @param code: string
 * @param callback: (address) => {}
 * @returns
 */
export const apiGetPostCodeInfo = (code, callback = () => {}) => {
  jpPostCode.get(code, callback);
};

/**
 *
 * @param {email: string} body
 * @returns
 */
export const apiResendMailClinic = (body = {}) => {
  return post(`/master/account/clinics/resend-email-register`, body);
};

export const apiGetClinics = () => get(url.API_GET_CLINIC);
export const apiGetClinic = (id) => get(url.API_GET_CLINIC + id);
export const apiUpdateClinic = (id, data) =>
  patch(url.API_UPDATE_CLINIC + id, data);

export const apiGetListClinics = (params) => {
  return get("/master/account/clinics/", { params });
};

export const apiExportCSVClinic = (params) => {
  return post("/master/account/clinics/export-csv", params);
};

export const apiExportCSVAllClinic = () => {
  return get("/master/account/clinics/export-csv-all");
};

export const apiDeleteClinicById = (params) => {
  return del(`/master/account/clinics/`, params);
};
export const apiDeleteClinic = (id) => del(url.API_UPDATE_CLINIC + id);
